module.exports = __webpack_public_path__ + "img/NEW-KoPo-Logo-Primary.5e421523.svg";